/**
 * Fixed notice copy for a refused or failed write (2.D deliverable 2). A notice never carries a
 * title, a note or any document text.
 */
export interface NoticeContext {
  /** Start has its own copy for `session_state`. */
  readonly action?: 'start' | 'write';
  /** The first issue code of a 422 `invalid_body`. */
  readonly issue?: string | undefined;
}

export const NETWORK_NOTICE = "Not saved: the server didn't answer.";

export function noticeFor(code: string | null, context: NoticeContext = {}): string {
  switch (code) {
    case null:
      return NETWORK_NOTICE;
    case 'session_state':
      return context.action === 'start'
        ? 'Another session is running.'
        : "This session can't change now.";
    case 'invalid_body':
      return context.issue === 'number_taken'
        ? 'That number is taken.'
        : "That wasn't saved. Check the fields and try again.";
    case 'row_conflict':
      return 'Someone changed this row first. The latest is shown.';
    case 'document_trashed':
      return 'That page is in the Trash.';
    case 'not_found':
      return "That session or page isn't there any more.";
    default:
      return 'Not saved. Try again.';
  }
}
